const portfolioList = [
  {
    title: "Kuber | Employee Management Application",
    description:
      "A web & mobile responsive employee management web application created using Node.js and React.js. This app provides a seamless management for employers. Includes custom MySQL/AWS Server-side REST API/relational database. Utilization and implementation of Lighthouse to improve website performance and SEO.",
    image: require("../../images/Kuber.png"),
    tools: ["AWS", "Node.js", "MySQL", "React", "SCSS", "Bootstrap"],
    github: "https://github.com/cheyennethreadgill/employee-management-app",
    demo: "https://kubermanagement.netlify.app/",
  },
  {
    title: "Kropp Gym | E-Commerce/Portfolio",
    description:
      "A web & mobile responsive e-commerce website created using Node.js and React.js, providing a seamless shopping experience for users. Includes custom MySQL/ Server-side REST API/relational database for order placements. Utilization of Third-party API for map integration and implementation of Lighthouse to improve website performance and SEO.",
    image: require("../../images/krp-gym.png"),
    tools: ["Node.js", "MySQL", "React", "SCSS", "Bootstrap"],
    github: "https://github.com/cheyennethreadgill/kropp-gym",
    demo: "https://kropp-gym.netlify.app",
  },
  {
    title: "Movie Flixx | Movie Application",
    description:
      "A responsive mobile & web app with dynamic content allowing users view, search and filter movies. Implementation of Third-party API for information from content database and Lighthouse for website optimization for improved performance and SEO.",
    image: require("../../images/movie-flixx-app.jpg"),
    tools: ["Javascript", "CSS", "HTML", "TypeScript"],
    github: "https://github.com/cheyennethreadgill/movie-flixx",
    demo: "https://moveflixx.netlify.app/",
  },
  {
    title: "Rent Now | Car Rental Service",
    description:
      "A portfolio website for company showcasing  dynamic content allowing users to rent cars for personal or business use. Users can filter cars based on their preferences. Futhermore, users can view specific car information per their request. The website provides a robust interface for searching, comparing, and reserving cars. Utilized front-end frameworks to create an interactive and visually appealing user interface.",
    image: require("../../images/rentnow.png"),
    tools: ["React", "SCSS", "Bootstrap"],
    github: "https://github.com/cheyennethreadgill/rent-now-car-rental-service",
    demo: "https://rentnow.netlify.app/",
  },
];

export default portfolioList;
